export default "__VITE_ASSET__DVQcA2Sc__"